import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EventsJoinPage } from './events-join.page';
import { PagesModule } from '../../pages.module';

const routes: Routes = [
  {
    path: '',
    component: EventsJoinPage
  }
];

@NgModule({
  imports: [
    PagesModule,
    RouterModule.forChild(routes)
  ],
  declarations: [EventsJoinPage]
})
export class EventsJoinPageModule { }
